import { Component, EventEmitter, Input, Output } from '@angular/core';
import { modalAnimations } from '@shared/animations/animations';

@Component({
    selector: 'app-simple-message-modal',
    templateUrl: './simple-message-modal.component.html',
    styleUrls: [],
    animations: modalAnimations,
})
export class SimpleMessageModalComponent {
    @Input() modalTitle: string;
    @Input() content: string;
    @Input() icon: string; // icon css class
    @Input() closeButton: string;
    @Input() visibility: boolean;
    @Input() centered = true;

    @Output() visibilityChange = new EventEmitter<boolean>();
    @Output() buttonClicked = new EventEmitter<boolean>();

    close() {
        this.visibility = false;
        this.visibilityChange.emit(this.visibility);
        this.buttonClicked.emit(true);
    }
}
